import React from 'react';

import { badgeClasses, Badge as MuiBadge, BadgeProps as MuiBadgeProps } from '@mui/material';

import { SxProp } from 'src/types/mui';

export const Badge: React.FC<React.PropsWithChildren<MuiBadgeProps>> = ({ children, ...props }) => {
  return (
    <MuiBadge
      sx={badgeStyle}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      overlap="circular"
      {...props}
    >
      {children}
    </MuiBadge>
  );
};

const badgeStyle: SxProp = {
  [`& .${badgeClasses.badge}`]: {
    color: 'white',
    backgroundColor: '#66bb6a',
    right: `35px`,
    fontSize: '8px',
    borderRadius: '30%',
    width: '5px',
    height: '12px',
    bottom: '2px',
  },
};
